const messages = {
  fleetWithOptions:
    "Ne morete izbrati flote, če ste izbrali opcije",
  addProduct: "Vaš izdelek je bil dodan v košarico.",
  addProducts: "Vaši izdelki so bili dodani v košarico.",
  profileSaved: "Podatki vašega profila so bili shranjeni",
  canAddProduct: "Nimate dovolj točk.",
  customerNumberSaved: "Številka stranke shranjena",
  customerNumberExist: "Številka stranke dostopna",
  complaintForm: "Vaša zahteva je bila sprejeta. Prosimo počakajte odgovor",
  openHourSaved: "Delovni čas je bil shranjen",
  changeParentId:
    "Ne morete spremeniti podružnice z večjo številko stranke, če ima podrejene podružnice.",
  requestSent: "Zahteva je bila poslana",
  completeProfileRequired:
    "Morate izpolniti vaš profil 100%, da boste lahko nadaljevali z nakupi v trgovini.",
  accessDenied: "Dostop zavrnjen",
  incomplete_address: "Naslov je nepopoln. Prosimo preverite",
  waitMoment: "Počakajte trenutek",
  downloadFinished: "Prenos zaključen",
  selectOneField: "Izberite eno polje",
  noVoucher: "Vavčer ni bil najden",
  cannotAddCsNumber: "Ne morete dodati številke stranke",
  messagesDeletedSuccess: "Sporočila so bila izbrisana.",
  messagesDeletedError: "Brisanje sporočil ni uspelo.",
  fillProfile: "Izpolnite profil, da boste lahko prenesli certifikat,",
  favoriteAdded: "Dodano med priljubljene.",
  favoriteRemoved: "Odstranjeno iz priljubljenih.",
};

export default {
  messages,
};
